import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EFDataService, EfMainAppMode, EfMainExternalFilter, EfMainFragment, EnvironmentService, PgHeaderStatusService, PgFooterStatusService } from 'pg-lib';

@Component({
    selector: 'app-ef-landing',
    templateUrl: './ef-landing.component.html',
    styleUrls: ['./ef-landing.component.scss'],
    standalone: false
})
export class EfLandingComponent implements OnInit, OnDestroy {

    constructor(private route:ActivatedRoute, private router:Router, private environmentService:EnvironmentService, private dataService:EFDataService, private pgHeaderStatusService:PgHeaderStatusService, private pgFooterStatusService:PgFooterStatusService) {}

    appMode:EfMainAppMode;
    externalFilter:EfMainExternalFilter;
    setView:string;
    fragment:EfMainFragment;
    hasOperatorsBanner:boolean;
    hasShowcase:boolean;
    hasShowcaseWithQR:string;
    showcaseContent:Array<{
        type: string;
        element: string;
    }>;

    isLoading = false;

    ngOnInit(): void {
        this.appMode = null;
        this.externalFilter = null;
        this.fragment = null;
        this.hasOperatorsBanner = false;
        this.hasShowcase = true;
        this.hasShowcaseWithQR = null;

        // CODICE DUPLICATO
        if(this.route.snapshot.queryParams != null) {
            if(this.route.snapshot.queryParams.iframe == 'true') this.appMode = 'iframe'
            else if(this.route.snapshot.queryParams.iframekiosk == 'true') this.appMode = 'iframekiosk'

            let _externalFilterString = this.route.snapshot.queryParams.filter;

            if(_externalFilterString != null) {
                try {
                    this.externalFilter = JSON.parse(_externalFilterString);
                }
                catch(ex) {
                    console.log('Failed to parse externalFilter', _externalFilterString)
                }
            }

            this.setView = this.route.snapshot.queryParams.view;
        }

        let _fragmentString = this.route.snapshot.fragment

        if(_fragmentString != null && _fragmentString != '') {
            try {
                this.fragment = JSON.parse(_fragmentString);
            }
            catch(ex) {
                let _split = _fragmentString.split('/')
                if(_split.length == 1) {
                    this.fragment = { product: _fragmentString }
                }
                else {
                    this.fragment = { view: _split[1], filter: { type: _split[2] as any }, product: _split[3] }
                }
            }
        }
        
        if(this.route.snapshot.params != null) {
            let _realmName = this.route.snapshot.params.realm

            if(_realmName != null && _realmName != '') {
                this.environmentService.setPublicRealm(_realmName);

                if(this.environmentService.publicRealm == null) {
                    this.router.navigate([''])
                }
            }
            
            let _environmentPid = this.route.snapshot.params.pid

            if(_environmentPid) {
                this.isLoading = true;

                this.dataService.getFinderEnvironment(_environmentPid).subscribe((data) => {
                    this.externalFilter = {}

                    if(data.data?.filter) {
                        for(let i in data.data.filter) {
                            this.externalFilter[i] = data.data.filter[i]
                        }
                    }
                    

                    this.environmentService.setPublicRealm(data.realm_id);
                    this.pgHeaderStatusService.setStatus(data.data);

                    let _footerStatus:any = {}

                    for(let i in data.data) {
                        if(/^footer/.test(i)) {
                            let _prop = i.replace(/^footer/, '')
                            _prop = _prop.charAt(0).toLowerCase() + _prop.substring(1);

                            _footerStatus[_prop] = data.data[i]
                        }
                    }

                    this.pgFooterStatusService.setStatus(_footerStatus);
                    
                    this.setView = data.data.view;
                    this.hasOperatorsBanner = data.data.operatorsBanner;
                    this.hasShowcase = data.data.showcase;
                    this.hasShowcaseWithQR = data.data.showcaseWithQR;
                    this.showcaseContent = data.data.showcaseContent;

                    this.isLoading = false;
                }, () => {
                    this.isLoading = false;
                })
            }
        }
    }

    ngOnDestroy(): void {
        this.pgHeaderStatusService.setStatus({});
        this.pgFooterStatusService.setStatus({});
    }

    onFragmentChange(fragment:EfMainFragment) {
        this.router.navigate([], { 
            fragment: 
                '/' + (fragment.view || '') + 
                '/' + (fragment.filter?.type || '') + 
                '/' + (fragment.product || '') 
        })
    }
}
